<template>
  <div>
    <div>
      <v-row v-if="selectedFolder == null">
        <v-col v-for="(fold, key) in files" :key="key" col="6">
          <v-card :loading="loading" class="mx-auto my-12" max-width="254">
            <template slot="progress">
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-card-title>{{ fold.name }}</v-card-title>
            <v-card-text>
              <div>Broj dokumenata : {{ fold.folder.childCount }}</div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>
            <v-card-actions>
              <v-btn
                color="deep-purple lighten-2"
                text
                @click="pregled(fold.id)"
              >
                Pregledaj
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="selectedFolder != null" class="mt-12">
        <v-row>
          <div>
            <v-btn
              color="deep-purple lighten-2"
              text
              @click="selectedFolder = null"
            >
              Povrat na spise
            </v-btn>
          </div>

          <v-col v-for="(dat, key) in filesInSpis" :key="key" col="6">
            <v-card :loading="loading" class="mx-auto my-12" max-width="254">
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-card-title>{{ dat.name }}</v-card-title>
              <v-card-text>
                <div>
                  Posljednje uređeno od: {{ dat.lastModifiedBy.user.email }}
                </div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>
              <v-card-actions>
                <v-btn
                  color="deep-purple lighten-2"
                  text
                  @click="openFile(dat.webUrl)"
                >
                  Otvori
                </v-btn>
                <v-btn color="red lighten-2" text @click="deleteFile(dat.id)">
                  Obriši
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- Tu je odjeljak koji se aktivira na odabir spisa -->
        <v-row>
          <v-col md="6">
            <input type="file" @change="onFileChange" />
            <v-btn color="deep-purple lighten-2" text @click="onUploadFile()">
              Upload
            </v-btn>
          </v-col>
          <v-col md="6">
            <v-text-field
            label="Naziv.nastavak"
            :v-model="naziv"
          ></v-text-field>
            <v-btn
              color="deep-purple lighten-2"
              text
              @click="createNewDocument()"
            >
              New DOCX
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import share from "../../apiCallers/sharepoint";
import { Document } from "docx"


export default {
  props: {
    accessToken: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      files: [],
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      filesInSpis: [],
      nazivDokumenta : ""
    };
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        this.getGroupById();
      }
    },
  },
  methods: {
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    deleteFile(fileId) {
      var path = "/drive/items/" + fileId;
      console.log("/groups/" + this.$route.params.uid + path);
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          this.pregled(this.selectedFolder);
        });
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0];
      this.selectedFile = selectedFile;
      console.log(this.selectedFile)
    },
    createNewDocument() {
      this.selectedFile = new Document({
        name: "Somefile.docx"
      })
    

      var formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("token", this.accessToken);
      formData.append("groupId", this.$route.params.uid);
      formData.append("sid", this.selectedFolder);
      formData.append("name", this.nazivDokumenta);
      console.log(this.nazivDokumenta);
      // appending file

      share.addDocumentInSpis(formData).then(() => {
        this.pregled(this.selectedFolder);
        this.nazivDokumenta = ""
      });
    },
    async onUploadFile() {
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("token", this.accessToken);
      formData.append("groupId", this.$route.params.uid);
      formData.append("sid", this.selectedFolder);
      formData.append("name", this.selectedFile.name);
      console.log(this.selectedFolder);
      // appending file

      share.addDocumentInSpis(formData).then(() => {
        this.pregled(this.selectedFolder);
      });
    },
    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      console.log(file);
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    pregled(sid) {
      this.selectedFolder = sid;
      console.log(sid);
      share
        .getDocumentsInSpis(this.accessToken, this.$route.params.uid, sid)
        .then((response) => {
          console.log(response.data.value);
          this.filesInSpis = response.data.value;
        });
    },
    getGroupById() {
      // console.log(this.$route.params.uid)
      share
        .getById(this.accessToken, this.$route.params.uid)
        .then((response) => {
          this.files = response.data.files.value;
          console.log(this.files);
        });
    },
  },
  mounted() {
    this.getGroupById();
    console.log("Tu je");
    var file = new File([], "proba.docx", {
      type: "word",
    });
    console.log(file);
  },
};
</script>

<style>
</style>